/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "ionic-angular/components/grid/grid";
import * as i2 from "ionic-angular/components/grid/row";
import * as i3 from "@angular/common";
import * as i4 from "./grid-row.component";
import * as i5 from "ionic-angular/navigation/nav-controller";
import * as i6 from "@ngrx/store";
import * as i7 from "../../../services/event.service";
import * as i8 from "../../../services/action.service";
var styles_GridRow = [""];
var RenderType_GridRow = i0.ɵcrt({ encapsulation: 0, styles: styles_GridRow, data: {} });
export { RenderType_GridRow as RenderType_GridRow };
function View_GridRow_1(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 8, "ion-grid", [["class", "grid"]], null, null, null, null, null)), i0.ɵdid(1, 16384, null, 0, i1.Grid, [], null, null), (_l()(), i0.ɵted(-1, null, ["\n  "])), (_l()(), i0.ɵeld(3, 0, null, null, 4, "ion-row", [["align-items-start", ""], ["class", "row"]], null, null, null, null, null)), i0.ɵdid(4, 16384, null, 0, i2.Row, [], null, null), (_l()(), i0.ɵted(-1, null, ["\n    "])), i0.ɵncd(null, 0), (_l()(), i0.ɵted(-1, null, ["\n  "])), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_GridRow_0(_l) { return i0.ɵvid(2, [(_l()(), i0.ɵted(-1, null, ["\n"])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_GridRow_1)), i0.ɵdid(2, 16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.visible !== false); _ck(_v, 2, 0, currVal_0); }, null); }
export function View_GridRow_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-grid-row", [], null, null, null, View_GridRow_0, RenderType_GridRow)), i0.ɵdid(1, 49152, null, 0, i4.GridRow, [i5.NavController, i6.Store, i7.UIEventHub, i8.ActionCreator, i0.Injector], null, null)], null, null); }
var GridRowNgFactory = i0.ɵccf("app-grid-row", i4.GridRow, View_GridRow_Host_0, { id: "id", title: "title", childrenKeys: "childrenKeys", visible: "visible" }, {}, ["*"]);
export { GridRowNgFactory as GridRowNgFactory };
//# sourceMappingURL=grid-row.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/widgets/grid/grid-row/grid-row.component.ngfactory.js
// module id = 473
// module chunks = 1